<template>
  <div class="pile-membres-cards">
    <div class="overlap">
      <div class="card">
        <div class="frame">
          <img class="image" alt="Image" src="/img/image-9-1.png" />
        </div>
        <div class="text-wrapper-2">GUANOMAD</div>
        <p class="p">
          Production et commercialisation d&apos;engrais organiques ...
        </p>
        <div class="frame-2">
          <img
            class="img"
            alt="Ic round phone"
            src="/img/ic-round-phone-14.svg"
          />
          <img
            class="img"
            alt="Material symbols"
            src="/img/material-symbols-mail-9.svg"
          />
          <img
            class="img"
            alt="Mdi internet"
            src="/img/mdi-internet-9.svg"
          />
        </div>
      </div>
      <div class="card-2">
        <div class="frame">
          <img class="image-2" alt="Image" src="/img/image-8-1.png" />
        </div>
        <div class="text-wrapper-2">EXPAM</div>
        <p class="p">
          Production et commer
          <br />
          cialisation d&apos;huiles essentielles de plantes...
        </p>
        <div class="frame-2">
          <img
            class="img"
            alt="Ic round phone"
            src="/img/ic-round-phone-14.svg"
          />
          <img
            class="img"
            alt="Material symbols"
            src="/img/material-symbols-mail-9.svg"
          />
          <img
            class="img"
            alt="Mdi internet"
            src="/img/mdi-internet-9.svg"
          />
        </div>
      </div>
      <div class="ep-arrow-right-bold-wrapper">
        <img
          class="ep-arrow-right-bold"
          alt="Ep arrow right bold"
          src="/img/ep-arrow-right-bold-2.svg"
        />
      </div>
      <div class="card-3">
        <div class="image-wrapper">
          <img class="image-3" alt="Image" src="/img/image-7-1.png" />
        </div>
        <div class="text-wrapper-2">ECOCERT</div>
        <p class="p">
          Agriculture biologique
          <br />
          Ecoproduit Commerce équitable, changement....
        </p>
        <div class="frame-2">
          <img
            class="img"
            alt="Ic round phone"
            src="/img/ic-round-phone-14.svg"
          />
          <img
            class="img"
            alt="Material symbols"
            src="/img/material-symbols-mail-9.svg"
          />
          <img
            class="img"
            alt="Mdi internet"
            src="/img/mdi-internet-9.svg"
          />
        </div>
      </div>
      <div class="card-4">
        <div class="img-wrapper">
          <img class="image-4" alt="Image" src="/img/image-6-1.png" />
        </div>
        <div class="text-wrapper-2">Codal</div>
        <p class="p">
          Production de conserves alimentaires à partir de fruits, légumes,
          épices...
        </p>
        <div class="frame-2">
          <img
            class="img"
            alt="Ic round phone"
            src="/img/ic-round-phone-14.svg"
          />
          <img
            class="img"
            alt="Material symbols"
            src="/img/material-symbols-mail-9.svg"
          />
          <img
            class="img"
            alt="Mdi internet"
            src="/img/mdi-internet-9.svg"
          />
        </div>
      </div>
      <div class="card-5">
        <div class="frame-3">
          <img class="image-5" alt="Image" src="/img/image-5-1.png" />
        </div>
        <div class="biolandes-madagascar">BIOLANDES MADAGASCAR</div>
        <p class="p">
          Distillation et extraction <br />
          Huiles essentielles <br />
          et extraits de plantes
        </p>
        <div class="frame-2">
          <img
            class="img"
            alt="Ic round phone"
            src="/img/ic-round-phone-14.svg"
          />
          <img
            class="img"
            alt="Material symbols"
            src="/img/material-symbols-mail-9.svg"
          />
          <img
            class="img"
            alt="Mdi internet"
            src="/img/mdi-internet-9.svg"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PileMembresCards",
};
</script>

<style>
.pile-membres-cards {
  margin: 0px 8vw;
  /* height: 400px; */
  /* left: 247px; */
  /* position: absolute; */
  /* top: 387px; */
  /* width: 1325px; */
}

.pile-membres-cards .overlap {
  height: 402px;
  position: relative;
  top: 1px;
  width: 348px;
}

.pile-membres-cards .card {
  align-items: flex-start;
  background-color: #e6e3b5;
  border-radius: 48px;
  box-shadow: 4px 4px 4px #00000040;
  display: flex;
  flex-direction: column;
  gap: 8px;
  height: 400px;
  left: 48px;
  padding: 0px 36px;
  position: absolute;
  top: 0;
  width: 300px;
}

.pile-membres-cards .frame {
  align-items: center;
  align-self: stretch;
  display: flex;
  flex-direction: column;
  gap: 10px;
  height: 160px;
  justify-content: flex-end;
  mix-blend-mode: multiply;
  position: relative;
  width: 100%;
}

.pile-membres-cards .image {
  height: 116px;
  margin-left: -22.00px;
  margin-right: -22.00px;
  object-fit: cover;
  position: relative;
  width: 272px;
}

.pile-membres-cards .text-wrapper-2 {
  align-self: stretch;
  color: #000000;
  font-family: "Mona-Sans-SemiBold", Helvetica;
  font-size: 24px;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 24px;
  position: relative;
  text-align: center;
}

.pile-membres-cards .p {
  align-self: stretch;
  color: #000000;
  font-family: "Mona-Sans-Light", Helvetica;
  font-size: 20px;
  font-weight: 300;
  letter-spacing: 0;
  line-height: 24px;
  position: relative;
}

.pile-membres-cards .frame-2 {
  align-items: center;
  align-self: stretch;
  display: flex;
  flex: 0 0 auto;
  gap: 32px;
  justify-content: center;
  position: relative;
  width: 100%;
}

.pile-membres-cards .img {
  height: 36px;
  position: relative;
  width: 36px;
}

.pile-membres-cards .card-2 {
  align-items: flex-start;
  background-color: #e6e3b5;
  border-radius: 48px;
  box-shadow: 4px 4px 4px #00000040;
  display: flex;
  flex-direction: column;
  gap: 8px;
  height: 400px;
  left: 35px;
  padding: 0px 36px;
  position: absolute;
  top: 2px;
  width: 300px;
}

.pile-membres-cards .image-2 {
  height: 131.5px;
  position: relative;
  width: 180px;
}

.pile-membres-cards .ep-arrow-right-bold-wrapper {
  align-items: center;
  background-color: #ffffff1a;
  border-radius: 100px;
  box-shadow: 0px 4px 4px #00000040;
  display: flex;
  gap: 10px;
  height: 36px;
  justify-content: center;
  left: 271px;
  padding: 10px;
  position: absolute;
  top: 181px;
  width: 48px;
}

.pile-membres-cards .ep-arrow-right-bold {
  height: 24px;
  margin-bottom: -4.00px;
  margin-top: -4.00px;
  position: relative;
  width: 24px;
}

.pile-membres-cards .card-3 {
  align-items: flex-start;
  background-color: #e6e3b5;
  border-radius: 48px;
  box-shadow: 4px 4px 4px #00000040;
  display: flex;
  flex-direction: column;
  gap: 8px;
  height: 400px;
  left: 24px;
  padding: 0px 36px;
  position: absolute;
  top: 1px;
  width: 300px;
}

.pile-membres-cards .image-wrapper {
  align-items: center;
  align-self: stretch;
  display: flex;
  flex-direction: column;
  gap: 10px;
  height: 160px;
  justify-content: center;
  position: relative;
  width: 100%;
}

.pile-membres-cards .image-3 {
  align-self: stretch;
  height: 100px;
  object-fit: cover;
  position: relative;
  width: 100%;
}

.pile-membres-cards .card-4 {
  align-items: flex-start;
  background-color: #e6e3b5;
  border-radius: 48px;
  box-shadow: 4px 4px 4px #00000040;
  display: flex;
  flex-direction: column;
  gap: 8px;
  height: 400px;
  left: 10px;
  padding: 0px 36px;
  position: absolute;
  top: 1px;
  width: 300px;
}

.pile-membres-cards .img-wrapper {
  align-items: flex-start;
  align-self: stretch;
  display: flex;
  gap: 10px;
  height: 160px;
  justify-content: center;
  position: relative;
  width: 100%;
}

.pile-membres-cards .image-4 {
  height: 153px;
  position: relative;
  width: 146px;
}

.pile-membres-cards .card-5 {
  align-items: flex-start;
  background-color: #e6e3b5;
  border-radius: 48px;
  box-shadow: 4px 4px 4px #00000040;
  display: flex;
  flex-direction: column;
  gap: 8px;
  height: 400px;
  left: 0;
  padding: 0px 36px;
  position: absolute;
  top: 1px;
  width: 300px;
}

.pile-membres-cards .frame-3 {
  align-items: flex-start;
  align-self: stretch;
  display: flex;
  flex-direction: column;
  gap: 10px;
  height: 135px;
  justify-content: center;
  position: relative;
  width: 100%;
}

.pile-membres-cards .image-5 {
  align-self: stretch;
  height: 39px;
  object-fit: cover;
  position: relative;
  width: 100%;
}

.pile-membres-cards .biolandes-madagascar {
  align-self: stretch;
  color: #000000;
  font-family: "Mona-Sans-Bold", Helvetica;
  font-size: 20px;
  font-weight: 700;
  letter-spacing: 0;
  line-height: 24px;
  position: relative;
}
</style>